<template>
  <el-cascader
    ref="elCascader"
    v-loading="loading && isNotInCommonForm"
    element-loading-spinner="el-icon-loading"
    :style="{ width }"
    size="small"
    v-model="data"
    v-bind="$attrs"
    :options="selectOptions"
    @change="handleChange"
    :props="{
      checkStrictly: multiple,
      value: 'name',
      label: 'name',
      children: 'child'
    }"
    clearable
  >
  </el-cascader>
</template>

<script>
export default {
  props: {
    value: {
      type: [Array, String]
    },
    query: {
      type: String,
      default: ''
    },
    multiple: {
      type: Boolean,
      default: true
    },
    isNotInCommonForm: {
      type: Boolean,
      default: true
    },
    autoQuery: {
      type: Boolean,
      default: true
    },
    width: {
      type: String,
      default: '200px'
    }
  },
  created() {
    if (this.query && this.autoQuery) {
      this.$ajax.get(this.query).then((res) => {
        this.selectOptions = res.data
      })
    }
  },
  data() {
    return {
      data: this.value,
      selectOptions: [],
      loading: false
    }
  },
  watch: {
    value(val) {
      this.data = val
    }
  },
  methods: {
    queryArea() {
      this.loading = true
      this.$ajax.get(this.query).then((res) => {
        this.selectOptions = res.data
        this.$nextTick(() => {
          this.loading = false
        })
      })
    },
    handleChange(val) {
      if (!val || val.length <= 0) {
        this.clear()
      }
      this.$emit('input', val)
    },
    clear() {
      this.$nextTick(() => {
        // 清空选中的节点
        this.$refs.elCascader.$refs.panel.clearCheckedNodes()
        // 设置为空可以让节点不高亮显示
        this.$refs.elCascader.$refs.panel.activePath = []
      })
    }
  }
}
</script>
